import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import {
  getJobSearchList,
  getJobSearchListSuccess,
} from "../../store/jobsList/actions";
import { Card, CardBody, CardHeader } from "reactstrap";
import "./common.styles.scss";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { createPortal } from "react-dom";
import LoadingSpinner from "./Spinner";
import useSearchPopover from "./useSearchPopover";
import { timerJobId } from "../../store/timeEntries/action";

// Same clipping problem (and fix) as CustomSelect: the results list rendered
// inline at z-index 100 inside AppModal's `overflow: auto` DialogContent, so it
// was cut off in AddMultipleTimeEntries. Now portalled to <body> and anchored to
// the search input at the 1350 menu tier.
const RESULTS_MAX_HEIGHT = 400;

// Change #100144 - pinned jobs (Task 24504) go to the top of the list. The
// backend already orders them that way; sorting here as well keeps it right
// while an older backend without FlagPinned is still deployed (the field is
// then missing and the order is left untouched).
const isPinned = (job) => String(job?.FlagPinned ?? "0") === "1";
const pinnedFirst = (list) =>
  [...(list ?? [])].sort((a, b) => Number(isPinned(b)) - Number(isPinned(a)));

export default function JobSearchList({
  dropDownTimer,
  handleSelectJobFromSearchResults,
  selectedJob,
  searchQuery,
  setSearchQuery,
  // Task 24840 - lets a host (the timer pop-out) open its own "create job"
  // modal from the "Add New Job" button below. Optional: when not supplied the
  // button is a no-op, exactly as it was before.
  onAddNewJob,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { jobSearchListDataAPI, jobSearchListDataLoading } = useSelector(
    (state) => ({
      jobSearchListDataAPI: state.Jobs.jobSearchListData, //?.job_list,
      jobSearchListDataLoading: state.Jobs.jobSearchListDataLoading,
    })
  );
  const { timeEntryListOpenLive } = useSelector((state) => ({
    timeEntryListOpenLive:
      state.TimeEntries.timeEntryListOpenLive?.timeentry_list,
  }));

  const [searchResults, setSearchResults] = useState([]);
  const [anchorWidth, setAnchorWidth] = useState(0);
  const {
    open: showSearchResults,
    close: closeSearchResults,
    coords,
    anchorRef,
    popRef,
    openMenu,
    guardSelect,
  } = useSearchPopover({ width: anchorWidth, maxHeight: RESULTS_MAX_HEIGHT });

  const openResults = useCallback(
    (e) => {
      const rect = anchorRef.current?.getBoundingClientRect();
      if (rect?.width) setAnchorWidth(rect.width);
      openMenu(e);
    },
    [anchorRef, openMenu]
  );

  useEffect(() => {
    if (isEmpty(jobSearchListDataAPI)) return;
    if (jobSearchListDataAPI.status === 200) {
      setSearchResults(pinnedFirst(jobSearchListDataAPI?.job_list));
    } else {
      setSearchResults([]);
      toast.error(jobSearchListDataAPI?.message);
    }

    dispatch(getJobSearchListSuccess([]));
  }, [jobSearchListDataAPI]);

  useEffect(() => {
    if (searchQuery === "") {
      setSearchResults([]);
      return;
    }
    let searchQueryFilter = searchQuery;
    searchQueryFilter?.toLocaleLowerCase();
    let delayTimer = setTimeout(() => {
      dispatch(getJobSearchList({ id: searchQueryFilter }));
    }, 300);
    return () => clearTimeout(delayTimer);
  }, [searchQuery]);

  return (
    <div ref={anchorRef}>
      <div>
        {selectedJob ? (
          <div>
            <Card className={"m-0"}>
              <div
                className={
                  "p-2 btn btn-soft-info m-0 d-flex flex-column flex-wrap  text-start"
                }
              >
                <div className={"d-flex flex-column flex-wrap "}>
                  <div></div>
                  <div>
                    {isPinned(selectedJob) && (
                      <i
                        className={"fa-solid fa-thumbtack text-warning me-1"}
                        title={"Pinned job"}
                        aria-label={"Pinned job"}
                      ></i>
                    )}
                    <span className={"me-1"}>#{selectedJob?.Id},</span>
                    {selectedJob?.Title}
                  </div>
                </div>

                <div
                  className={"job-search-customer-name-badge"}
                  title={`Cutomer ${selectedJob?.Customer_FullName}`}
                >
                  <span className={"me-1"}>Customer: </span>{" "}
                  {selectedJob?.Customer_FullName}
                </div>
                <div className={"d-flex justify-content-between"}>
                  <button
                    onClick={(e) => {
                      //Unassign Job
                      dispatch(timerJobId(""));
                      openResults(e);
                    }}
                    className={"btn btn-danger m-1 p-1 btn-sm"}
                  >
                    Unassign
                  </button>
                  <button
                    className={"btn btn-primary m-1 p-1 btn-sm"}
                    onClick={() => {
                      //Open Job
                      history.push(`/single-job/${selectedJob?.Id}`);
                    }}
                  >
                    Open
                  </button>
                </div>
              </div>
            </Card>
          </div>
        ) : (
          <div>
            {/*<h6>JobSearchList</h6>*/}
            <input
              placeholder={"Job Search"}
              onFocus={openResults}
              type="search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className={"form-control"}
            />
          </div>
        )}

        {showSearchResults &&
          searchQuery.length > 0 &&
          coords &&
          createPortal(
            <div
              ref={popRef}
              className={"jobSearchList-search-results-wrapper"}
              style={{
                position: "fixed",
                zIndex: 1350,
                left: coords.left,
                top: coords.top,
                bottom: coords.bottom,
                width: anchorWidth || undefined,
                maxHeight: coords.maxHeight,
              }}
            >
            {jobSearchListDataLoading ? (
              <LoadingSpinner />
            ) : (
              <>
                {searchResults?.length !== 0 ? (
                  <div>
                    {searchResults?.map((item, index) => (
                      //     Use properties For Job ID = Id for Job Title = Title for Customer Name = Customer_FullName
                      <Card key={index} className={"m-1"}>
                        <div
                          className={
                            "p-2 btn btn-soft-info m-1 d-flex flex-column flex-wrap  text-start"
                          }
                        >
                          <div className={"d-flex flex-column flex-wrap "}>
                            <div></div>
                            <div>
                              {isPinned(item) && (
                                <i
                                  className={
                                    "fa-solid fa-thumbtack text-warning me-1"
                                  }
                                  title={"Pinned job"}
                                  aria-label={"Pinned job"}
                                ></i>
                              )}
                              <span className={"me-1"}>#{item?.Id},</span>
                              {item?.Title}
                            </div>
                          </div>

                          <div
                            className={"job-search-customer-name-badge"}
                            title={`Cutomer ${item?.Customer_FullName}`}
                          >
                            <span className={"me-1"}>Customer: </span>{" "}
                            {item?.Customer_FullName}
                          </div>
                          <div className={"d-flex justify-content-between"}>
                            <button
                              className={"btn btn-success m-1 p-1 btn-sm"}
                              onClick={guardSelect(() => {
                                handleSelectJobFromSearchResults(item);
                                closeSearchResults();
                              })}
                            >
                              Assign
                            </button>
                            <button
                              className={"btn btn-primary m-1 p-1 btn-sm"}
                              onClick={() => {
                                //Open Job
                                history.push(`/single-job/${item?.Id}`);
                              }}
                            >
                              Open
                            </button>
                          </div>
                        </div>
                      </Card>
                    ))}
                  </div>
                ) : (
                  <div className={"text-center p-4"}>
                    <h6>No Results Found</h6>
                    <p className={"text-muted"}>
                      Adjust your search: {searchQuery}
                    </p>
                  </div>
                )}
              </>
            )}

            <div className={"m-2"}>
              <button
                className={"w-100 btn btn-info"}
                onClick={() => {
                  // Task 24840 - hand the typed text over as the starting title
                  // and let the host open its create-job modal. Close the
                  // results popover so it isn't left floating over the modal.
                  onAddNewJob && onAddNewJob(searchQuery);
                  closeSearchResults();
                }}
              >
                Add New Job
              </button>
            </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
}
